import { asyncToGenerator as _asyncToGenerator } from '../_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from '../node_modules/regenerator-runtime/runtime.esm.js';
import { Buffer } from 'buffer/';
import axios from 'axios';
import { fetch } from './fetch.esm.js';

function isURIEncoded(uri) {
  try {
    return uri !== decodeURIComponent(uri);
  } catch (_unused) {
    return false;
  }
}

function isStreamAnImage(_x) {
  return _isStreamAnImage.apply(this, arguments);
}

function _isStreamAnImage() {
  _isStreamAnImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var source, response, magicNumbers, imageSignatures, isBinaryImage, chunkAsString, isSvgImage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            source = axios.CancelToken.source();
            _context.next = 4;
            return fetch.get(url, {
              responseType: 'arraybuffer',
              headers: {
                Range: 'bytes=0-1023'
              },
              cancelToken: source.token,
              onDownloadProgress: function onDownloadProgress(progressEvent) {
                if (progressEvent.loaded > 1024) {
                  // Cancel the request if more than 1024 bytes have been downloaded
                  source.cancel('Aborted to prevent downloading the entire file.');
                }
              }
            });

          case 4:
            response = _context.sent;

            // Check the binary signature (magic numbers) of the data
            if (response.data instanceof ArrayBuffer) {
              magicNumbers = new DataView(response.data).getUint32(0).toString(16);
            } else {
              magicNumbers = response.data.readUInt32BE(0).toString(16);
            }

            imageSignatures = ['ffd8ff', '89504e47', '47494638', '49492a00', '4d4d002a', '424d'];
            isBinaryImage = imageSignatures.some(function (signature) {
              return magicNumbers.startsWith(signature);
            }); // Check for SVG image

            chunkAsString = Buffer.from(response.data).toString();
            isSvgImage = /<svg[\s\S]*?xmlns="http:\/\/www\.w3\.org\/2000\/svg"/.test(chunkAsString);
            return _context.abrupt("return", isBinaryImage || isSvgImage);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);

            if (axios.isCancel(_context.t0)) {
              console.error('Stream request was canceled:', _context.t0.message);
            } else {
              console.error('Error checking stream:', _context.t0);
            }

            return _context.abrupt("return", false);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));
  return _isStreamAnImage.apply(this, arguments);
}

function isImageURI(url) {
  var encodedURI = isURIEncoded(url) ? url : encodeURI(url);
  return new Promise(function (resolve) {
    fetch({
      url: encodedURI,
      method: 'HEAD'
    }).then(function (result) {
      if (result.status === 200) {
        // retrieve content type header to check if content is image
        var contentType = result.headers['content-type'];

        if (contentType != null && contentType.startsWith('application/octet-stream')) {
          // if image served with generic mimetype, do additional check
          resolve(isStreamAnImage(encodedURI));
        }

        resolve(contentType == null ? void 0 : contentType.startsWith('image/'));
      } else {
        resolve(false);
      }
    })["catch"](function (error) {
      console.warn('isImageURI: fetch error', error); // if error is not cors related then fail

      if (typeof error.response !== 'undefined') {
        // in case of cors, use image api to validate if given url is an actual image
        resolve(false);
        return;
      }

      if (!globalThis.hasOwnProperty('Image')) {
        // fail in NodeJS, since the error is not cors but any other network issue
        resolve(false);
        return;
      }

      var img = new Image();

      img.onload = function () {
        resolve(true);
      };

      img.onerror = function () {
        resolve(false);
      };

      img.src = encodedURI;
    });
  });
}

export { isImageURI };
//# sourceMappingURL=isImageURI.esm.js.map
